import { api } from '@/global/api'
import { TrackingInfoUtms } from '@/modules/simulator/api/types'

export interface InitializedSimulation {
  id: string
}

export interface InitializeSimulationPayload {
  version: string
  trackingInfo: TrackingInfoUtms
}

export interface InitializeSimulationResponse {
  simulation: InitializedSimulation
}

export const initializeSimulation = async (
  payload: InitializeSimulationPayload
) => {
  const { data } = await api.post<InitializeSimulationResponse>(
    '/simulation',
    payload
  )
  return data
}
